import React, { useState } from "react";
import { colors } from "../../../../../../../../themes/Colors";
import {
  BaseButtons,
  TextInputFieldArea,
} from "../../../../../../../common-components";
import User from "../../../../../../../user/User";

const RequestPopUp = ({
  display,
  setCommentPopUp,
  setLoading,
  setToastPop,
  setMessage,
  setPopUpTitle,
  customerData,
  data,
  auth,
}) => {
  const [request, setRequest] = useState("");

  const submitRequest = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/addTaskRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            taskId: data._id,
            request: request,
            createdBy: auth.firstName + " " + auth.lastName,
            user: customerData.firstName + " " + customerData.lastName,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);

        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage("request sent");
        setCommentPopUp(false);
        // setToastPop(true);
      } else {
        setLoading(false);
      }
      //  else {
      //   setLoading(false);
      //   setPopUpTitle("FAILED");
      //   setMessage("Unable to find customers, " + " " + respnseData.message);
      //   setToastPop(true);
      // }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      // setMessage(
      //   "Unable to login into account, please wait 5 mins then try again or contact support" +
      //     " " +
      //     err
      // );
      // setToastPop(true);
    }
  };
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        width: "95%",
        height: display ? "92%" : 0,
        backgroundColor: colors.white,
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"X"}
          width={40}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => setCommentPopUp(false)}
          borderRadius={8}
        />
        <div style={{ fontWeight: "bold", fontSize: 18, marginLeft: 20 }}>
          ADD NEW REQUEST HERE
        </div>
      </div>
      <div
        style={{
          width: "100%",
          marginTop: 80,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TextInputFieldArea
          labelTitle={"What would you like to request?"}
          height={100}
          mini={true}
          size={"100%"}
          width={"90%"}
          value={request}
          onChange={(e) => setRequest(e.target.value)}
        />
        <div style={{ minHeight: 10 }} />
        <BaseButtons
          label={"SUBMIT"}
          backgroundColor={colors.secondaryDarkBlue}
          width={"95%"}
          borderRadius={4}
          onClick={() => submitRequest()}
        />
      </div>
    </div>
  );
};

export default RequestPopUp;
